import { PatientConsentViewModel } from "./PatientConsentViewModel";
export class PatientConsentInterimPageViewModel extends PatientConsentViewModel {
}
